export type ZoomLevel = 0 | 1 | 2;

export type ZoomConfig = {
  level: ZoomLevel;
  label: string;
  minColWidth: number;
  rowHeight: number;
  rowGap: number;
  showLabels: boolean;
  // Day gridlines only render at Week/Detail zoom; Overview additionally
  // collapses to week-only boundary lines when the range exceeds 60 days,
  // to avoid grid noise (see `showDayGridlines` usage in GridLines.tsx —
  // that extra range check lives there, not here, since it needs numDays).
  showDayGridlines: boolean;
};

// Tight vertical pitch between a bundle parent and its stacked children
// (message -> task -> task chains), overriding the normal rowHeight+rowGap
// pitch at those row boundaries only. Not zoom-dependent.
export const TIGHT_ROW_PITCH = 34;

// Fixed vertical gap between lanes. Not zoom-dependent.
export const LANE_GAP = 12;

export const ZOOM_LEVELS: readonly [ZoomConfig, ZoomConfig, ZoomConfig] = [
  {
    level: 0,
    label: 'Overview',
    minColWidth: 8,
    rowHeight: 32,
    rowGap: 6,
    showLabels: false,
    showDayGridlines: false
  },
  {
    level: 1,
    label: 'Week view',
    minColWidth: 70,
    rowHeight: 46,
    rowGap: 10,
    showLabels: true,
    showDayGridlines: true
  },
  {
    level: 2,
    label: 'Detail view',
    minColWidth: 140,
    rowHeight: 46,
    rowGap: 10,
    showLabels: true,
    showDayGridlines: true
  }
];

export const getZoomConfig = (zoom: ZoomLevel): ZoomConfig => ZOOM_LEVELS[zoom];

export const clampZoom = (zoom: number): ZoomLevel => {
  if (zoom <= 0) return 0;
  if (zoom >= 2) return 2;
  return zoom as ZoomLevel;
};
